module.exports = __webpack_public_path__ + "static/media/34.7c618d16.mp3";